import { render, staticRenderFns } from "./VoucherDialog.vue?vue&type=template&id=58ff558c"
import script from "./VoucherDialog.vue?vue&type=script&lang=js"
export * from "./VoucherDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports